import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import FooterContainer from '../containers/Footer/Footer.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import AgilePurchaseBySector from '../containers/AgilePurchaseBySector/AgilePurchaseBySector.container'
import AgilePurchaseSection from '../containers/AgilePurchaseSection/AgilePurchaseSection.container'
import AgilePurchaseProviders from '../containers/AgilePurchaseProviders/AgilePurchaseProviders.container'
import AgilePurchaseBuyers from '../containers/AgilePurchaseBuyers/AgilePurchaseBuyers.container'
import AgilePurchaseTradedProviders from '../containers/AgilePurchaseTradedProviders/AgilePurchaseTradedProviders.container'
import AgilePurchaseTradedProducts from '../containers/AgilePurchaseTradedProducts/AgilePurchaseTradedProducts.container'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'

/**
 * The AgilePurchase's page.
 */
const AgilePurchase = () => (
  <BrandLayout footer={<FooterContainer margin="0" />}>
    <TopNavbarContainer menuActive={routes.agilePurchase} />
    <AgilePurchaseSection />
    <AgilePurchaseBySector />
    <ProtectByFeatures rule={features => features['cl.chilecompra.datos-abiertos/new-section-agile-purchase']}>
      <AgilePurchaseTradedProducts />
    </ProtectByFeatures>
    <AgilePurchaseProviders />
    <AgilePurchaseBuyers />
    <AgilePurchaseTradedProviders />
  </BrandLayout>
)

export default AgilePurchase
